module.exports = __webpack_public_path__ + "img/avatar_3.9c123e74.png";